import { routes } from "../site";

/**
 * SSS sayfası (/sss). Kaynak: "ZHesap Site İçerikleri - İletişim, SSS,
 * Partnerlik" dosyası, 2. bölüm; metinler birebir.
 *
 * Cevaplardaki bağlantılar `[etiket](adres)` biçiminde yazılır, sayfa bunları
 * bağlantıya çevirir. Adresler `routes`'tan gelir ki sayfa adresi değişince
 * burası kendiliğinden güncel kalsın.
 */
export interface FaqItem {
  q: string;
  a: string;
}

export interface FaqCategory {
  id: string;
  title: string;
  items: FaqItem[];
}

const link = (label: string, href: string) => `[${label}](${href})`;

export const sssPage = {
  href: routes.sss,
  hero: {
    eyebrow: "SSS",
    title: "Sıkça Sorulan",
    titleAccent: "Sorular",
    leadBefore: "Aradığın cevabı bulamazsan ",
    leadLink: { label: "bize yaz", href: routes.iletisim },
    leadAfter: ", ekibimiz yardımcı olsun.",
  },
  search: {
    label: "Sorularda ara",
    placeholder: "Soru ya da kelime ara (ör. kurulum, iade, KDV)",
  },
  tabsLabel: "Kategoriler",
  allLabel: "Tümü",
  empty: {
    /** {q} aranan ifadeyle değiştirilir. */
    title: "“{q}” için bir sonuç bulamadık",
    desc: "Başka bir kelime dene ya da sorunu doğrudan ekibimize ilet.",
    cta: { label: "Bize Yaz", href: routes.iletisim },
  },
  bottom: {
    title: "Cevabını bulamadın mı?",
    desc: "Ekibimiz en geç 1 iş günü içinde dönüş yapar.",
    secondary: { label: "Bize Yaz", href: routes.iletisim },
    primary: { label: "7 Gün Ücretsiz Dene", href: "/#erken-erisim" },
  },
  categories: [
    {
      id: "genel",
      title: "Genel",
      items: [
        {
          q: "ZHesap nedir?",
          a: "ZHesap, e-ticaret yapan işletmeler için finansal kontrol, kârlılık ve karar platformudur. Satış, maliyet, komisyon, kargo ve kesinti verilerini tek yerde birleştirir; her siparişte, üründe ve kanalda gerçekte ne kazandığını gösterir.",
        },
        {
          q: "Kimler için uygun?",
          a: "Pazaryerlerinde satış yapanlar, kendi e-ticaret sitesinden satanlar, mağaza ve online kanalı birlikte yürüten omnichannel işletmeler ve birden fazla marka veya mağaza yönetenler için tasarlandı.",
        },
        {
          q: "Muhasebe programımın yerine mi geçiyor?",
          a: "Hayır. ZHesap bir muhasebe programı değil, karar platformudur. Muhasebe geçmişi kayıt altına alır; ZHesap ise bugün hangi üründe, hangi kampanyada, hangi kanalda kazanıp kaybettiğini gösterip doğru kararı vermene yardımcı olur.",
        },
        {
          q: "ZHesap’ın gösterdiği kâr neden pazaryeri panelindekinden farklı?",
          a: "Pazaryeri panelleri genellikle ciroyu gösterir. ZHesap ise ürün maliyeti, komisyon, kargo, hizmet bedeli, iade ve diğer kesintileri düşerek gerçek net kârını hesaplar.",
        },
      ],
    },
    {
      id: "kurulum",
      title: "Kurulum ve Entegrasyon",
      items: [
        {
          q: "Hangi platformlarla entegre çalışıyor?",
          a: `Pazaryerleri, e-ticaret altyapıları, ERP ve kargo firmalarıyla entegre çalışır. Güncel listeyi ${link("Entegrasyonlar", routes.entegrasyonlar)} sayfasında bulabilirsin.`,
        },
        {
          q: "Kurulum ne kadar sürer?",
          a: "Çoğu işletme için yaklaşık 15 dakika. Mağazalarını bağladığın anda veriler aktarılmaya başlar; ürün maliyetlerini tanımladığında kârlılık ekranların hazır hâle gelir. Kurulum boyunca ekibimiz sana eşlik eder.",
        },
        {
          q: "Teknik bilgi gerekiyor mu?",
          a: "Hayır. Bağlantılar birkaç adımda yapılır, kod yazman gerekmez.",
        },
        {
          q: "Kaç mağaza bağlayabilirim?",
          a: "Tüm paketlerde aynı tüzel kişiliğe veya satıcı hesabına bağlı sınırsız pazaryeri ve mağaza bağlayabilirsin.",
        },
      ],
    },
    {
      id: "fiyat",
      title: "Fiyatlandırma ve Ödeme",
      items: [
        {
          q: "Paketler arasındaki fark nedir?",
          a: `Starter, Scale ve Signature paketleri; kullanıcı sayısı, dahil modüller ve aylık sipariş ile yapay zekâ hakları bakımından ayrışır. Ayrıntılı karşılaştırma ${link("Fiyatlandırma", routes.fiyatlar)} sayfasında.`,
        },
        {
          q: 'Fiyatlara KDV dahil mi?',
          a: 'ZHesap, Teknoloji Geliştirme Bölgesi (Teknopark) bünyesinde geliştirilen bir yazılım platformudur. Sunulan yazılım hizmetleri, yürürlükteki mevzuat çerçevesinde 3065 sayılı KDV Kanunu’nun Geçici 20/1. maddesi kapsamında KDV’den istisnadır. Bu nedenle belirtilen fiyatlara ayrıca KDV eklenmez. Faturanızda istisna kapsamı belirtilerek, gördüğünüz tutar üzerinden düzenlenir.',
        },
        {
          q: "ZHesap yıllık mı ödeniyor?",
          a: "Evet. ZHesap paketleri yıllık lisansla sunulur. Fiyatlandırma sayfasında gördüğün aylık tutar, yıllık lisans bedelinin aylık karşılığıdır. Fiyatın 12 ay boyunca sabit kalır; yıl içinde zam görmezsin. Lisans süren dolduğunda güncel fiyat üzerinden 12 ay daha yenilenir; yenilenmesini istemezsen bitişten en az 15 gün önce haber vermen yeterli.",
        },
        {
          q: "Ödeme seçenekleri neler?",
          a: "Kredi kartı, banka kartı veya havale/EFT ile ödeme yapabilirsin. Sana en uygun ödeme seçeneğini demo görüşmesinde birlikte belirliyoruz.",
        },
        {
          q: "Sipariş hakkım dolarsa ne olur?",
          a: "Hakkın dolmaya yaklaştığında bildirim alırsın. Dilersen tek seferlik ek sipariş hakkı alabilir veya paketini yükseltebilirsin. Sipariş hakların her ay lisans başlangıç gününde yenilenir.",
        },
        {
          q: "Ek kullanıcı ekleyebilir miyim?",
          a: "Evet. Tüm paketlere kullanıcı başına ek kullanıcı tanımlayabilirsin. Her kullanıcı aynı anda tek oturumla çalışır.",
        },
        {
          q: "Aylık 15.000’den fazla sipariş işliyorum, hangi paket bana uygun?",
          a: `Üç paket de 15.000+ sipariş için kullanılabilir. Hacmine ve ihtiyaç duyduğun modüllere göre sana özel kurumsal teklif hazırlıyoruz. → ${link("Demo Talep Et", "/#erken-erisim")}`,
        },
        {
          q: "Ücretsiz deneyebilir miyim?",
          a: "Evet. Demo görüşmesinden sonra ZHesap’ı kendi mağaza verilerinle 7 gün ücretsiz deneyebilirsin.",
        },
      ],
    },
    {
      id: "abonelik",
      title: "Abonelik ve İptal",
      items: [
        {
          q: "Paketimi daha sonra yükseltebilir miyim?",
          a: "Evet, dilediğin zaman. Yükseltmede yalnızca sözleşmenin kalan süresine düşen fark gün bazında hesaplanır ve yeni kapasiten hemen tanımlanır. Paket düşürme ise yenileme döneminde yapılır.",
        },
        {
          q: "Lisansımı nasıl iptal ederim?",
          a: `Lisansın 12 aylık bir kullanım hakkıdır ve süre dolmadan sona erdirilemez. Yenilenmesini istemiyorsan bitişten en az 15 gün önce panelinden veya ${link("info@zhesap.com", "mailto:info@zhesap.com")} adresine yazman yeterli. Lisansın süre sonuna kadar açık kalır, sonraki dönem için ödeme alınmaz.`,
        },
        {
          q: "Yıllık lisansım bitince ne olur?",
          a: "Lisans bitişinden en az 30 gün önce yenileme bedelini sana bildiriyoruz. Bitişten en az 15 gün önce aksini bildirmezsen lisansın güncel fiyat üzerinden 12 ay daha yenilenir.",
        },
        {
          q: "Ücret iadesi var mı?",
          a: `ZHesap ticari amaçla kullanılan bir yazılım hizmeti olduğundan ödenen bedeller iade edilmez. Karar vermeden önce 7 günlük ücretsiz deneme ile ZHesap’ı kendi verinle test etmeni öneriyoruz. Ayrıntılar: ${link("İptal & İade Koşulları", routes.yasal.iptalIade)}.`,
        },
        {
          q: "Aboneliğim bitince verilerime ne olur?",
          a: "ZHesap’taki ham veriler, satış kanallarından çekilen verilerdir ve kendi kanallarında durmaya devam eder. ZHesap’ın ürettiği hesaplama ve analizler ise platforma özeldir, dışa aktarılamaz. Aboneliğin sona erdiğinde verilerin 15 gün boyunca saklanır; bu sürede geri dönersen kaldığın yerden devam edersin. 15 günün sonunda tüm verilerin kalıcı olarak silinir.",
        },
      ],
    },
    {
      id: "guvenlik",
      title: "Veri Güvenliği ve Yapay Zekâ",
      items: [
        {
          q: "Verilerim güvende mi?",
          a: `Evet. Verilerin KVKK standartlarına uygun olarak korunur: aktarım sırasında SSL/TLS ile, saklama sırasında şifreleme yöntemleriyle güvence altındadır. Erişimler rol bazlı yetkilendirmeyle sınırlandırılır ve düzenli yedekleme yapılır. Ayrıntılar: ${link("Veri Güvenliği Politikası", routes.yasal.guvenlik)}.`,
        },
        {
          q: "Sunucularınız saldırılara karşı nasıl korunuyor?",
          a: "ZHesap sunucuları güvenlik duvarı ve saldırı önleme sistemleriyle korunur ve düzenli güvenlik testlerinden geçirilir. Tespit edilen her bulgu hızla giderilir.",
        },
        {
          q: "Verilerimi başkalarıyla paylaşıyor musunuz?",
          a: "Hayır. Verilerin pazarlama amacıyla hiçbir üçüncü kişiye satılmaz veya kiralanmaz. Yalnızca hizmetin çalışması için gereken altyapı sağlayıcılarıyla, gizlilik yükümlülüğü altında işlenir.",
        },
        {
          q: "Yapay zekâ özellikleri verilerimi nasıl kullanıyor?",
          a: "Z’eki ve AI Müşteri İlişkileri gibi özellikler yalnızca senin onayınla açılır. Yapay zekâya hiçbir kişisel veri gönderilmez; kişiyi tanımlayabilecek bilgiler işlemden önce maskelenir. Hizmet sağlayıcılarımız verilerini model eğitiminde kullanmaz.",
        },
        {
          q: "Kart bilgilerimi saklıyor musunuz?",
          a: "Hayır. Ödemeler lisanslı ödeme kuruluşu üzerinden alınır; kart bilgilerin ZHesap sistemlerinde saklanmaz.",
        },
      ],
    },
  ] as FaqCategory[],
} as const;
